import React from 'react';
import { Row, Table } from 'antd';
import { useHistory } from 'react-router-dom';

import { Label, message } from 'components/common';
import {
  //GreenColor,
  SmartBackButton,
  SmartBlock,
  SmartButton,
  //SmartFormLabel,
  //SmartScanner,
  SmartSpace,
  //SmartSpin,
  playSound,
} from 'components/Sales/Smart/SmartComponent';
//import { poControlStatus } from 'constants/enums';
import { poStatusMap } from 'constants/enums';
import { fetchPoLineList } from 'services/purchaseOrder';
import { convertTimeByUtc } from 'utils';
import { PoRecvActionType as PRAction, PoRecvStep } from './context';

type Props = ReduxStateProps & {
  gotoAnchor?: Function;
};

const PoInfo = (props: Props) => {
  const { useRef, useState } = React;
  const [inited, setInited] = useState(false);
  const history = useHistory();
  const infoRef = useRef<any>(null);

  const columns = [
    {
      title: 'SKU',
      dataIndex: 'sku',
    },
    {
      title: 'PO Qty',
      dataIndex: 'quantity',
    },
    {
      title: 'Received Quantity',
      dataIndex: 'humanReceiveQty',
    },
  ];

  const doNextStep = () => {
    if (props.gotoAnchor) props.gotoAnchor(PoRecvStep.RecvPo);
  };

  // eslint-disable-next-line
  const getPoLines = async (id: string, warehouseCode: string) => {
    const { dispatch, state } = props;
    const crossWarehouseReceive = state.crossWarehouseReceive;

    try {
      dispatch({ type: PRAction.SetLockScreen, params: true }); 

      const data = await fetchPoLineList(
        id,
        crossWarehouseReceive === '0' ? warehouseCode : undefined,
      );
      const lines = data.map((item) => {
        return {
          ...item,
          receivingLocationCode: undefined,
          receivingLocationNum: undefined,
          //receivingWarehouseCode: selectedWarehouse?.warehouseCode,
          receivingWarehouseCode: state.currentPo.warehouseCode,
          uom: item.uom || 'EA',
          uomRate: item.uomRate || 1,
          baseQty: 0,
          orderUom: item.uom,
          orderUomRate: item.uomRate,
          orderBaseQty: item.uomBaseQty,
          receivingQty: item.receivingQty || 0,
        };
      });
      dispatch({ type: PRAction.SetPoLines, params: lines });
    } catch (err) {
      playSound('error');
      message.error({ content: `Fetched items in po error: ${err}` });
    } finally {
      dispatch({ type: PRAction.SetLockScreen, params: false }); 
    }
  };

  const lineCardBodyClassName = (line: StringKAnyVPair) => {
    const {
      humanReceiveQty = 0,
      closingQty = 0,
      waitCloseQty = 0,
      receivingQty = 0,
      quantity = 0,
    } = line;
    const cls = ['ant-card-body', 'card-body-p10'];
    const sum = humanReceiveQty + closingQty + waitCloseQty + receivingQty;

    if (quantity === sum) {
      cls.push('po-body-success');
    } else if (quantity < sum) {
      cls.push('po-body-failed');
    }

    return cls.join(' ');
  };

  const lineCardClassName = (lineIdx: number) => {
    const cls = ['ant-card',  'ant-card-bordered'];

    if (lineIdx < props.state.poLines.length - 1) cls.push('mb-10');

    return cls.join(' ');
  };

  const onPageBack = () => {
    const { dispatch } = props;

    setTimeout(() => {
      // clearing must be excuting after the component has been umounted
      //console.log('clear pl');
      dispatch({ type: PRAction.SetPoLines, params: [] });
    }, 100);
    history.goBack();
  };

  const nextStepButton = () => {
    return (
      <SmartButton
        onClick={doNextStep}
        size="large"
        style={{marginBottom: 0}}
        type="primary"
      >
        Next
      </SmartButton>
    );
  };

  // eslint-disable-next-line
  const renderLines = () => {
    const { state } = props;
    return state.poLines.map((l: StringKAnyVPair, i: number) => (
      <div className={lineCardClassName(i)} key={`pl-${l.poLineNum}`}>
        <div className={lineCardBodyClassName(l)}>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>SKU</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.sku}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Product Name</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.title}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>PO Qty</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.quantity}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>PO UOM</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.orderUom}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>PO Rate</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.orderUomRate}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>PO Base Qty</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.orderBaseQty}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Receiving Qty</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}></Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>LOT#</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.lotNumber}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Receiving UOM</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.uom}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Receiving Rate</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.uomRate}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Receiving Base Qty</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.baseQty}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Total Received Base Qty</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.humanReceiveQty}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Receipt Warehouse</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.receivingWarehouseCode}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Receipt Location</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.receivingLocationCode}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Waiting for Closing</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.waitCloseQty}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Closing</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.closingQty}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Received Batch</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.batchNumber}</Label>
          </Row>
          <Row>
            <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Note</Label>
            <Label className="label-grey" theme={{fontSize: '1.2em'}}>{l.publicNote}</Label>
          </Row>
        </div>
      </div>
    ));
  };

  React.useEffect(() => {
    const { state } = props;

    if (infoRef.current && !inited && state.poLines.length === 0) {
      //console.log('st', state);
      getPoLines(state.currentPo.poId, state.currentPo.warehouseCode);
      setInited(true);
    }
  }, [getPoLines, inited, props]);

  return (<>
    <SmartSpace className="ant-card ant-card-bordered" ref={infoRef}>
      <div className="ant-card-body card-body-p10">
        <Row>
          <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>PO#</Label>
          <Label className="label-grey" theme={{fontSize: '1.2em'}}>{props.state.currentPo.poNumber || ''}</Label>
        </Row>
        <Row>
          <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Supplier</Label>
          <Label className="label-grey" theme={{fontSize: '1.2em'}}>{props.state.currentPo.vendorName || ''}</Label>
        </Row>
        <Row>
          <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>Container #</Label>
          <Label className="label-grey" theme={{fontSize: '1.2em'}}>{props.state.currentPo.container || ''}</Label>
        </Row>
        <Row>
          <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>PO Status</Label>
          <Label className="label-grey" theme={{fontSize: '1.2em'}}>{poStatusMap[props.state.currentPo.poStatusNum] || ''}</Label>
        </Row>
        <Row>
          <Label className="tail-colon2" theme={{fontSize: '1.2em'}}>PO Date</Label>
          <Label className="label-grey" theme={{fontSize: '1.2em'}}>{convertTimeByUtc(props.state.currentPo.poDate, '', '', 'MM/DD/YYYY')}</Label>
        </Row>
      </div>
    </SmartSpace>
    {props.state.poLines.length > 0 && (<>
      <Table
        columns={columns}
        dataSource={props.state.poLines}
        //onRow={listRowProps}
        pagination={false}
        rowKey="poLineNum"
        //scroll={{y: tableScrollHeight()}}
        size="middle"
      />
      <SmartSpace>
        {[1, 2].indexOf(props.state.currentPo.poStatusNum) > -1 && (
          <SmartBlock>
            {nextStepButton()}
          </SmartBlock>
        )}
      </SmartSpace>
    </>)}
    <SmartSpace>
      <SmartBackButton
        expand={[1, 2].indexOf(props.state.currentPo.poStatusNum) < 0}
        onClick={() => onPageBack()}
      />
    </SmartSpace>
    {/*lines.length > 0 && (
      <SmartSpace>
        {renderLines()}
      </SmartSpace>
    )*/}
  </>);
};

export default PoInfo;
